export const OPEN_DELETE_FORM_MODAL = 'OPEN_DELETE_FORM_MODAL';
export const CLOSE_DELETE_FORM_MODAL = 'CLOSE_DELETE_FORM_MODAL';

function openDeleteFormModal(formsToDelete) {
  return {
    type: OPEN_DELETE_FORM_MODAL,
    isDeleteFormModalShown: true,
    formsToDelete
  };
}

function closeDeleteFormModal() {
  return {
    type: CLOSE_DELETE_FORM_MODAL,
    isDeleteFormModalShown: false,
    deleteFormResponse: null,
    deleteFormError: null
  };
}

export function showDeleteFormModal(formsToDelete) {
  return (dispatch) => {
    dispatch(openDeleteFormModal(formsToDelete));
  };
}

export function hideDeleteFormModal() {
  return (dispatch) => {
    dispatch(closeDeleteFormModal());
  };
}
